import { 
  STATUS_BOOKED, STATUS_ARRIVED,
  STATUS_STARTED, STATUS_RADIOLOGY_STARTED, STATUS_RADIOLOGY_FINISHED,
  STATUS_CONSULTATION_RESTARTED, STATUS_CONSULTATION_REVIEWED, STATUS_SUSPENDED,
  STATUS_PAID, STATUS_FINISHED, STATUS_CANCELLED
} from 'services/constants';

export const isValidTime = (time) => {
  if(!time) {
    return '';
  }
  if (/0001-01-01/.test(time)) {
    return '';
  }
  return true;
};

export const transSteps = {
  ['booking']: { title: 'appointment_booked', pastTitle: 'appointment_booked' },
  ['arrive']: { title: 'patient_arrival', pastTitle: 'patient_arrived_time_line' },
  ['consultation']: { title: 'consultation', pastTitle: 'appointment_started' },
  ['_consultation_']: { title: 'consultation', pastTitle: 'appointment_started' },
  [STATUS_SUSPENDED]: { title: 'consultation_suspended', pastTitle: 'consultation_suspended' },
  [STATUS_RADIOLOGY_STARTED]: { title: 'radiology_start', pastTitle: 'radiology_started' },
  [STATUS_RADIOLOGY_FINISHED]: { title: 'radiology_finish', pastTitle: 'radiology_finished' },
  [STATUS_CONSULTATION_RESTARTED]: { title: 'consultation_restart', pastTitle: 'consultation_restarted' },
  [STATUS_FINISHED]: { title: 'appointment_finish', pastTitle: 'appointment_finished' },
  ['radiology']: { title: 'radiology_started',  pastTitle: 'radiology_finished' },
  ['pay']: { title: 'appointment_payment', pastTitle: 'payment_completed' },   
  ['feedback']: { title: 'feedback', pastTitle: 'patient_left_feedback' },
  [STATUS_CANCELLED]: { title: 'consultation_canceled', pastTitle: 'consultation_canceled' }
};